import React, { useState, useMemo, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useOrderData } from '../../../hooks/useOrderData';
import { useLineItems } from '../../../hooks/useLineItems';
import { useLineItemImages } from '../../../hooks/useLineItemImages';
import { LineItemNavigator } from './LineItemNavigator';
import { ImageGrid } from './ImageGrid';
import { ReviewActionsFooter } from './ReviewActionsFooter';
import { useOrderSelection } from '../../../hooks/useOrderSelection';
import { useLineItemSelection } from '../../../hooks/useLineItemSelection';

interface AcceptPendingReviewDialogProps {
  orderData: ReturnType<typeof useOrderData>;
  orderSelection: ReturnType<typeof useOrderSelection>;
  lineItemsHook: ReturnType<typeof useLineItems>;
  lineItemSelection: ReturnType<typeof useLineItemSelection>;
  visible: boolean;
  onHide: () => void;
}

export const AcceptPendingReviewDialog: React.FC<AcceptPendingReviewDialogProps> = ({
  orderData,
  orderSelection,
  lineItemsHook,
  lineItemSelection,
  visible,
  onHide,
}) => {
  const lineItemImagesHook = useLineItemImages(lineItemsHook.selectedLineItem);

  return (
    <Dialog
      header="Product Images Reviewer"
      visible={visible}
      onHide={() => {
        onHide();
        lineItemImagesHook.onHide();
        lineItemsHook.setSelectedLineItem(null);
      }}
      style={{ width: '95vw', height: '90vh' }}
      modal
      maximizable
      data-testid="accept-pending-review-dialog"
    >
      <div style={{ 
        height: '80vh',
        display: 'grid',
        gridTemplateColumns: '35% 1fr',
        gridTemplateRows: '2fr 1fr',
        gridTemplateAreas: `
          "navigator images"
          "navigator actions"
        `,
        gap: '1rem',
        width: '100%'
      }}>
        {/* Left Panel - Line Items Navigator */}
        <div style={{ 
          gridArea: 'navigator',
          borderRight: '2px solid #dee2e6',
          paddingRight: '1rem',
          minHeight: 0,
          overflow: 'hidden'
        }}>
          <LineItemNavigator
            orderData={orderData}
            orderSelection={orderSelection}
            lineItemsHook={lineItemsHook}
            lineItemImagesHook={lineItemImagesHook}
          />
        </div>

        {/* Top Right - Image Grid */}
        <div style={{ 
          gridArea: 'images',
          borderBottom: '2px solid #dee2e6',
          paddingBottom: '0.5rem',
          minHeight: 0,
          overflow: 'hidden'
        }}>
          <ImageGrid
            lineItemsHook={lineItemsHook}
            lineItemImagesHook={lineItemImagesHook}
          />
        </div>

        {/* Bottom Right - Actions Footer */}
        <div style={{ 
          gridArea: 'actions',
          paddingTop: '0.5rem',
          minHeight: 0,
          overflow: 'hidden'
        }}>
          {orderSelection.selectedOrder && <ReviewActionsFooter
            orderData={orderData}
            orderSelection={orderSelection}
            lineItemsHook={lineItemsHook}
          />}
        </div>
      </div>
    </Dialog>
  );
}; 